<div *ngIf="schedules.length > 0" class="schedules">
  <p class="schedules__title">Horaires d&apos;ouverture&nbsp;:</p>
  <ul class="schedules__list">
    <li *ngFor="let schedule of schedules; trackBy: trackByScheduleName" class="schedules__schedule">
      <p>
        <span class="schedules__schedule__label">{{ schedule.label | titlecase }}</span>
        <span
          class="schedules__schedule__hours"
          *ngFor="let hour of schedule.hours; trackBy: trackByHour; let last = last"
        >
          {{ hour.from }} - {{ hour.to }} <ng-container *ngIf="!last">•</ng-container>
        </span>
      </p>
    </li>
  </ul>
</div>
